import { render, staticRenderFns } from "./DownloadAttachmentDropDownItem.vue?vue&type=template&id=40824dab&scoped=true&"
import script from "./DownloadAttachmentDropDownItem.vue?vue&type=script&lang=js&"
export * from "./DownloadAttachmentDropDownItem.vue?vue&type=script&lang=js&"
import style0 from "./DownloadAttachmentDropDownItem.vue?vue&type=style&index=0&id=40824dab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40824dab",
  null
  
)

component.options.__file = "DownloadAttachmentDropDownItem.vue"
export default component.exports